import * as serializers from '../../serializers'

export const preLogin = (res) => {
  const headers = res?.headers || {}
  const data = res?.data || {}
  const slt = res?.headers && res?.headers['x-slt']

  return {
    headers,
    data: {
      ...data,
      slt
    }
  }
}

export const login = serializers.application

export const logout = serializers.application
